<template>
  <ErrorModal />
  <div class="user-profile-page">
    <div id="q-app" style="min-height: calc(100vh - 310px)">
      <div class="menu-medium">
        <q-btn flat class="menu-item" @click="goToTab('myBasicDetails')">
          Mijn gegevens</q-btn
        >
        <q-btn
          flat
          class="menu-item"
          @click="goToTab('newsletter')"
          v-if="isVind"
        >
          Profiel en nieuwsbrief
        </q-btn>
        <q-btn
          flat
          class="menu-item"
          @click="goToTab('savedItems')"
          v-if="isVind"
        >
          Opgeslagen items
        </q-btn>
        <q-btn
          flat
          class="menu-item"
          @click="goToTab('hiddenSchemes')"
          v-if="isVind"
        >
          Verborgen regelingen
        </q-btn>
      </div>
      <div class="menu-small">MENU SMALL</div>
      <div class="page-container">
        <q-splitter
          v-model="splitterModel"
          style="min-height: calc(100vh - 310px)"
        >
          <template v-slot:before class="menu-lg">
            <div style="min-height: 15vh" class="menu-lg">
              <div class="q-pa-md q-gutter-sm">
                <q-avatar class="profile-avatar" rounded size="100px">{{
                  firstName.charAt(0).toUpperCase()
                }}</q-avatar>
              </div>
            </div>
            <q-tabs v-model="tab" vertical class="tab-heading-color menu-lg">
              <q-tab
                name="myBasicDetails"
                label="Mijn gegevens"
                style="justify-content: initial"
                class="menu-lg"
              ></q-tab>
              <q-tab
                v-if="isVind"
                name="newsletter"
                label="Profiel en nieuwsbrief"
                style="justify-content: initial"
                class="menu-lg"
              ></q-tab>
              <q-tab
                v-if="isVind"
                name="savedItems"
                label="Opgeslagen items"
                style="justify-content: initial"
                class="menu-lg"
              ></q-tab>

              <q-tab
                v-if="isVind"
                name="hiddenSchemes"
                label="Verborgen items"
                style="justify-content: initial"
                class="menu-lg"
              ></q-tab>
              <q-tab
                v-if="isVind && showAdminPanel"
                name="userManagement"
                label="Accountbeheer"
                style="justify-content:initial"
                class="menu-lg"
              ></q-tab>
            </q-tabs>
          </template>

          <template v-slot:after class="menu-lg">
            <q-tab-panels
              v-model="tab"
              animated
              swipeable
              vertical
              transition-prev="jump-up"
              transition-next="jump-up"
              style="min-height: calc(100vh - 310px)"
            >
              <q-tab-panel name="myBasicDetails">
                <div class="text-h4 q-mb-md text-left tab-heading-color">
                  Mijn gegevens
                </div>
                <q-card>
                  <q-tabs
                    v-model="subTab"
                    dense
                    class="text-grey"
                    align="left"
                    narrow-indicator
                  >
                    <q-tab name="myBasicDetailsSubTab" label="Mijn gegevens">
                    </q-tab>
                    <q-tab
                      name="generalSettings"
                      label="Algemene instellingen"
                      v-if="isVind"
                    >
                    </q-tab>
                  </q-tabs>

                  <q-separator />

                  <q-tab-panels v-model="subTab" animated>
                    <q-tab-panel name="myBasicDetailsSubTab">
                      <q-input
                        v-if="isVind"
                        outlined
                        label="Organisatie"
                        type="text"
                        lazy-rules
                        dense
                        class="q-ma-sm"
                        style="
                          width: 40vw;
                          margin-top: 20px;
                          margin-bottom: 20px;
                        "
                        disable
                        v-model="customer"
                      ></q-input>
                      <q-input
                        outlined
                        label="Voornaam"
                        type="text"
                        lazy-rules
                        dense
                        class="q-ma-sm"
                        style="
                          width: 40vw;
                          margin-top: 20px;
                          margin-bottom: 20px;
                        "
                        :disable="enableEditMode == false"
                        v-model="firstName"
                      >
                      </q-input
                      ><q-input
                        outlined
                        label="Achternaam"
                        type="text"
                        lazy-rules
                        dense
                        class="q-ma-sm"
                        style="
                          width: 40vw;
                          margin-top: 20px;
                          margin-bottom: 20px;
                        "
                        :disable="enableEditMode == false"
                        v-model="lastName"
                      >
                      </q-input>
                      <!--       <q-input
                        outlined
                        label="Gebruikersnaam"
                        type="text"
                        lazy-rules
                        dense
                        class="q-ma-sm"
                        style="width: 40vw; margin-top: 20px; margin-bottom: 20px"
                        :disable="enableEditMode == false"
                        v-model="username"
                      >
                      </q-input> -->

                      <q-input
                        outlined
                        label="Email"
                        type="text"
                        lazy-rules
                        dense
                        class="q-ma-sm"
                        style="
                          width: 40vw;
                          margin-top: 20px;
                          margin-bottom: 20px;
                        "
                        :disable="enableEditMode == false"
                        v-model="email"
                      >
                      </q-input>

                      <div class="on-right" style="width: 40vw">
                        <div
                          v-if="enableEditMode == false"
                          class="q-ma-sm float-right"
                        >
                          <q-btn
                            color="primary"
                            icon="edit"
                            class="save-btn"
                            @click="enableEditMode = true"
                          >
                            <q-tooltip>Bewerk</q-tooltip>
                          </q-btn>
                        </div>
                        <div
                          v-if="enableEditMode == true"
                          class="q-ma-sm float-right"
                        >
                          <q-btn
                            color="primary"
                            icon="save"
                            class="save-btn"
                            @click="saveChanges"
                          >
                            <q-tooltip>Opslaan</q-tooltip>
                          </q-btn>
                        </div>
                      </div>
                    </q-tab-panel>
                    <q-tab-panel name="generalSettings" v-if="isVind">
                      <div
                        class="open-details-question q-pb-md"
                        style="width: 40vw"
                      >
                        <q-checkbox
                          dense
                          size="sm"
                          v-model="openDetailsInNewTab"
                          label="Open details in nieuwe tab?"
                          class="checkbox"
                        />
                      </div>
                    </q-tab-panel>
                  </q-tab-panels>
                </q-card>
              </q-tab-panel>

              <q-tab-panel name="savedItems">
                <SavedItems />
              </q-tab-panel>

              <q-tab-panel name="newsletter" v-if="isVind">
                <div class="tags-tabs">
                  <div class="text-h4 q-mb-md text-left tab-heading-color">
                    Profiel en nieuwsbrief
                  </div>
                  <div class="text-h6 q-mb-md text-left">
                    Creëer je profiel
                  </div>
                  <q-card>
                    <q-tabs
                      v-model="tagsTab"
                      dense
                      class="text-grey"
                      align="justify"
                      narrow-indicator
                    >
                      <q-tab name="audiences" label="Voor wie">
                        <q-badge color="#0a1f8f" class="tag-badge" floating>{{
                          favoriteAudience.length
                        }}</q-badge>
                      </q-tab>
                      <q-tab name="purposes" label="Onderwerp">
                        <q-badge color="#0a1f8f" class="tag-badge" floating>{{
                          favoritePurposes.length
                        }}</q-badge>
                      </q-tab>
                      <q-tab name="locations" label="Locatie">
                        <q-badge color="#0a1f8f" class="tag-badge" floating>{{
                          selectedFavoriteLocations.length
                        }}</q-badge>
                      </q-tab>
                      <!-- <q-tab name="industries" label="Industrie">
                        <q-badge color="#0a1f8f" class="tag-badge" floating>{{
                          favoriteIndustries.length
                        }}</q-badge>
                      </q-tab> -->
                    </q-tabs>

                    <q-separator />

                    <q-tab-panels v-model="tagsTab" animated>
                      <q-tab-panel name="audiences">
                        <div style="min-width: 250px">
                          <div
                            class="sidebar-margin item-width"
                            style="min-width: 280px; width: 27vw"
                          >
                            <div class="tree q-mt-lg">
                              <span
                                class="filter-box-heading"
                                v-text="audienceNodes.label"
                              ></span>
                              <q-input
                                dense
                                outlined
                                v-model="filterAudience"
                                label="Zoeken"
                                class="tree-searchbox"
                              >
                              </q-input>
                              <div class="test">
                                <q-scroll-area
                                  :bar-style="barStyle"
                                  :thumb-style="thumbStyle"
                                  visible
                                  class="tree-scroll-area"
                                >
                                  <q-tree
                                    ref="audienceTree"
                                    :filter="filterAudience"
                                    :filter-method="myFilterMethod"
                                    :nodes="audienceNodes.options"
                                    node-key="id"
                                    tick-strategy="leaf"
                                    v-model:ticked="tickedAudience"
                                    v-model:expanded="expandedAudience"
                                    v-model:selected="selectedAudience"
                                    @update:ticked="
                                      updateAudiencePairs(tickedAudience);
                                      sendAudienceUpdates(tickedAudience);
                                    "
                                    class="default-tree"
                                  />
                                </q-scroll-area>
                              </div>
                            </div>
                          </div>
                        </div>
                      </q-tab-panel>

                      <q-tab-panel name="purposes">
                        <div style="min-width: 250px">
                          <div
                            class="sidebar-margin item-width"
                            style="min-width: 280px; width: 27vw"
                          >
                            <div class="tree q-mt-lg">
                              <span
                                class="filter-box-heading"
                                v-text="purposesNodes.label"
                              ></span>
                              <q-input
                                dense
                                outlined
                                v-model="filterPurposes"
                                label="Zoeken"
                                class="tree-searchbox"
                              >
                              </q-input>
                              <div class="test">
                                <q-scroll-area
                                  :bar-style="barStyle"
                                  :thumb-style="thumbStyle"
                                  visible
                                  class="tree-scroll-area"
                                >
                                  <q-tree
                                    ref="purposesTree"
                                    :filter="filterPurposes"
                                    :filter-method="myFilterMethod"
                                    :nodes="purposesNodes.options"
                                    node-key="id"
                                    tick-strategy="leaf"
                                    v-model:ticked="tickedPurposes"
                                    v-model:expanded="expandedPurposes"
                                    v-model:selected="selectedPurposes"
                                    @update:ticked="
                                      updatePurposesPairs(tickedPurposes);
                                      sendPurposesUpdates(tickedPurposes);
                                    "
                                    class="default-tree"
                                  />
                                </q-scroll-area>
                              </div>
                            </div>
                          </div>
                        </div>
                      </q-tab-panel>
                      <!-- This is just hidden for now, don't remove it:-->
                      <!-- <q-tab-panel name="industries">
                        <div style="min-width: 250px">
                          <div
                            class="sidebar-margin item-width"
                            style="min-width: 280px; width: 27vw"
                          >
                            <div class="tree q-mt-lg">
                              <span
                                class="filter-box-heading"
                                v-text="industriesNodes.label"
                              ></span>
                              <q-input
                                dense
                                outlined
                                v-model="filterIndustries"
                                label="Zoeken"
                                class="tree-searchbox"
                              >
                              </q-input>
                              <div class="test">
                                <q-scroll-area
                                  :bar-style="barStyle"
                                  :thumb-style="thumbStyle"
                                  visible
                                  class="tree-scroll-area"
                                >
                                  <q-tree
                                    ref="industriesTree"
                                    :filter="filterIndustries"
                                    :filter-method="myFilterMethod"
                                    :nodes="industriesNodes.options"
                                    node-key="id"
                                    tick-strategy="leaf"
                                    v-model:ticked="tickedIndustries"
                                    v-model:expanded="expandedIndustries"
                                    v-model:selected="selectedIndustries"
                                    @update:ticked="
                                      updateIndustriesPairs(tickedIndustries);
                                      sendIndustriesUpdates(tickedIndustries);
                                    "
                                    class="default-tree"
                                  />
                                </q-scroll-area>
                              </div>
                            </div>
                          </div>
                        </div>
                      </q-tab-panel> -->

                      <q-tab-panel name="locations">
                        <div style="min-width: 250px" class="tag-selector">
                          <q-select
                            outlined
                            bg-color="white"
                            v-model="selectedFavoriteLocations"
                            multiple
                            :options="filterFavoriteLocationsTags"
                            option-value="label"
                            class="budget-input"
                            option-label="label"
                            use-input
                            placeholder="Zoek een locatie gemeente of provincie"
                            input-debounce="0"
                            behavior="menu"
                            use-chips
                            @filter="filterLocationsFn"
                            dense
                          >
                            <template v-slot:no-option>
                              <q-item>
                                <q-item-section class="text-grey">
                                  No results
                                </q-item-section>
                              </q-item>
                            </template>
                          </q-select>
                        </div>
                      </q-tab-panel>
                    </q-tab-panels>
                  </q-card>
                  <div class="text-h6 q-mb-md text-left">
                    Hoe vaak wil je de nieuwsbrief ontvangen?
                  </div>
                  <div class="q-gutter-sm text-left">
                    <q-radio
                      keep-color
                      v-model="frequency"
                      val="Dagelijks"
                      label="Dagelijks"
                      class="frequency-radio"
                    />
                    <q-radio
                      keep-color
                      v-model="frequency"
                      val="Wekelijks"
                      label="Wekelijks"
                      class="frequency-radio"
                    />
                    <q-radio
                      keep-color
                      v-model="frequency"
                      val="Maandelijks"
                      label="Maandelijks"
                      class="frequency-radio"
                    />
                    <q-radio
                      keep-color
                      v-model="frequency"
                      val="Nooit"
                      label="Nooit"
                      class="frequency-radio"
                    />
                  </div>
                  <!--        <div class="scheme-changes-question">
               
                    <q-checkbox
                      dense
                      size="sm"
                      v-model="schemeChangesInNewsletter"
                      label="Wil je wijzigingen in regelingen binnen dit profiel ook
                    ontvangen?"
                      class="checkbox"
                    />
                  </div> -->
                </div>
                <q-dialog v-model="showConfirmation">
                  <q-card>
                    <q-card-section class="row items-center">
                      <i class="las la-2x la-check"></i>
                      <span class="q-ml-sm">
                        Je ontvangt de subsidienieuwsbrief nu {{ frequencyNL }}
                      </span>
                    </q-card-section>

                    <q-card-actions align="right">
                      <q-btn
                        outline
                        label="Ok"
                        color="primary"
                        @click="disableConfirmation()"
                      />
                    </q-card-actions>
                  </q-card>
                </q-dialog>
              </q-tab-panel>

              <q-tab-panel name="hiddenSchemes" v-if="isVind">
                <HiddenSchemes />
              </q-tab-panel>
              <q-tab-panel name="userManagement" v-if="isVind">
                <UserManagement />
              </q-tab-panel>
            </q-tab-panels>
          </template>
        </q-splitter>
      </div>
    </div>
  </div>
</template>
<script>
import { ref, computed, onMounted } from 'vue';
import store from '../store/index.js';
import UserService from '../services/userprofile.service';
import FiltersService from '../services/filters.service';
import moment from 'moment';
import { useRoute } from 'vue-router';
import ErrorModal from '../components/userProfile-components/ErrorModal.vue';
import SavedItems from '../components/userProfile-components/SavedItems.vue';
import HiddenSchemes from '../components/userProfile-components/HiddenSchemes.vue';
import OrganisationsService from '../services/organisations.service.js';
import UserManagement from '../components/userProfile-components/UserManagement.vue';

export default {
  components: {
    SavedItems,
    HiddenSchemes,
    ErrorModal,
    UserManagement,
  },
  name: 'UserProfile',
  setup() {
    const route = useRoute();
    const tab = ref(route.params.tab);

    const tagsTab = ref('audiences');
    const filterAudience = ref('');
    const filterPurposes = ref('');
    //This is just hidden for now, don't remove it:
    //const filterIndustries = ref('');
    const expandedAudience = ref([]);
    const selectedAudience = ref([]);
    const expandedPurposes = ref([]);
    const selectedPurposes = ref([]);
    //This is just hidden for now, don't remove it:
    //const expandedIndustries = ref([]);
    //const selectedIndustries = ref([]);
    const audiencePairs = ref([]);
    const purposesPairs = ref([]);
    //This is just hidden for now, don't remove it:
    //const industriesPairs = ref([]);
    const audienceTree = ref(null);
    const purposesTree = ref(null);
    //This is just hidden for now, don't remove it:
    //const industriesTree = ref(null);
    const subTab = ref('myBasicDetailsSubTab');

    onMounted(() => {
      UserService.getUser();
      UserService.getHiddenSchemes();
      UserService.getFavoriteAudienceTags();
      UserService.getFavoritePurposesTags();
      //This is just hidden for now, don't remove it:
      //UserService.getFavoriteIndustriesTags();
      UserService.getFavoriteLocationsTags();
      UserService.getNewsletterFrequency();
      UserService.getProfileConfiguration();
      FiltersService.getDefaultFilters();
      //this is used for loading saved filters if organisations filters are included:
      OrganisationsService.getAllOrganisationsWithBasicInfo();
      store.commit('advancedSearch/clearSearchText');
      store.commit('advancedSearch/resetSearchFilter', false);
    });

    const favoriteAudience = computed({
      get: () => store.state.user.favoriteAudiencesIdsArray,
    });
    const favoritePurposes = computed({
      get: () => store.state.user.favoritePurposesIdsArray,
    });
    //This is just hidden for now, don't remove it:
    /*
    const favoriteIndustries = computed({
      get: () => store.state.user.favoriteIndustriesIdsArray,
    });
    */
    const tickedAudience = ref(favoriteAudience.value);

    const tickedPurposes = ref(favoritePurposes.value);

    //This is just hidden for now, don't remove it:
    //const tickedIndustries = ref(favoriteIndustries.value);

    //to add parent if all children are selected
    const updateAudiencePairs = (keys) => {
      audiencePairs.value = [];
      if (keys.length > 0) {
        for (let i = 0; i < keys.length; i++) {
          let node = audienceTree.value.getNodeByKey(keys[i]);
          audiencePairs.value.push(node);
        }
        var toAdd = [];
        for (let i = 0; i < audienceNodes.value.options.length; i++) {
          if (
            audienceNodes.value.options[i].children &&
            audienceNodes.value.options[i].children.length > 0
          ) {
            var hasAllChildrenTicked = true;

            for (
              let j = 0;
              j < audienceNodes.value.options[i].children.length;
              j++
            ) {
              if (
                !keys.includes(audienceNodes.value.options[i].children[j].id)
              ) {
                hasAllChildrenTicked = false;
                break;
              }
            }
            if (hasAllChildrenTicked)
              toAdd.push(audienceNodes.value.options[i]);
          } else {
            hasAllChildrenTicked = false;
          }
        }
        if (toAdd.length > 0) {
          for (let i = 0; i < toAdd.length; i++)
            audiencePairs.value.push(toAdd[i]);
        }
      }
    };

    //to add parent if all children are selected
    const updatePurposesPairs = (keys) => {
      purposesPairs.value = [];
      if (keys.length > 0) {
        for (let i = 0; i < keys.length; i++) {
          let node = purposesTree.value.getNodeByKey(keys[i]);
          purposesPairs.value.push(node);
        }
        var toAdd = [];
        for (let i = 0; i < purposesNodes.value.options.length; i++) {
          if (
            purposesNodes.value.options[i].children &&
            purposesNodes.value.options[i].children.length > 0
          ) {
            var hasAllChildrenTicked = true;

            for (
              let j = 0;
              j < purposesNodes.value.options[i].children.length;
              j++
            ) {
              if (
                !keys.includes(purposesNodes.value.options[i].children[j].id)
              ) {
                hasAllChildrenTicked = false;
                break;
              }
            }
            if (hasAllChildrenTicked)
              toAdd.push(purposesNodes.value.options[i]);
          } else {
            hasAllChildrenTicked = false;
          }
        }
        if (toAdd.length > 0) {
          for (let i = 0; i < toAdd.length; i++)
            purposesPairs.value.push(toAdd[i]);
        }
      }
    };

    //This is just hidden for now, don't remove it:
    //to add parent if all children are selected
    /*
    const updateIndustriesPairs = (keys) => {
      industriesPairs.value = [];
      if (keys.length > 0) {
        for (let i = 0; i < keys.length; i++) {
          let node = industriesTree.value.getNodeByKey(keys[i]);
          industriesPairs.value.push(node);
        }
        var toAdd = [];
        for (let i = 0; i < industriesNodes.value.options.length; i++) {
          if (
            industriesNodes.value.options[i].children &&
            industriesNodes.value.options[i].children.length > 0
          ) {
            var hasAllChildrenTicked = true;

            for (
              let j = 0;
              j < industriesNodes.value.options[i].children.length;
              j++
            ) {
              if (
                !keys.includes(industriesNodes.value.options[i].children[j].id)
              ) {
                hasAllChildrenTicked = false;
                break;
              }
            }
            if (hasAllChildrenTicked)
              toAdd.push(industriesNodes.value.options[i]);
          } else {
            hasAllChildrenTicked = false;
          }
        }
        if (toAdd.length > 0) {
          for (let i = 0; i < toAdd.length; i++)
            industriesPairs.value.push(toAdd[i]);
        }
      }
    };
    */

    const user = computed({
      get: () => store.state.user.user,
    });

    const enableEditMode = ref(false);

    const customer = computed({
      get: () => store.state.user.user.person.customer,
    });

    const username = computed({
      get: () => store.state.user.user.username,
      set: (value) => store.commit('user/updateUsername', value),
    });

    const email = computed({
      get: () => store.state.user.user.email,
      set: (value) => store.commit('user/updateEmail', value),
    });

    const firstName = computed({
      get: () => store.state.user.user.person.firstName,
      set: (value) => store.commit('user/updateFirstName', value),
    });

    const lastName = computed({
      get: () => store.state.user.user.person.lastName,
      set: (value) => store.commit('user/updateLastName', value),
    });

    const frequency = computed({
      get: () => store.state.user.newsletterFrequencyType,
      set: (value) => {
        store.commit('user/updateNewsletterFrequencyType', value);
        UserService.setNewsletterFrequency(value);
        frequencyNL.value = value;
      },
    });

    const frequencyNL = ref('');

    const schemeChangesInNewsletter = computed({
      get: () => store.state.user.schemeChangesInNewsletterStatus,
      set: (value) => {
        store.commit('user/updateSchemeChangesInNewsletterStatus', value);
        UserService.setSchemeChangesInNewsletterStatus(value);
      },
    });

    const openDetailsInNewTab = computed({
      get: () => store.state.user.openDetailsInNewTab,
      set: (value) => {
        store.commit('user/updateOpenDetailsInNewTab', value);
        UserService.setOpenDetailsInNewTab(value);
      },
    });

    const updatedUser = {
      username: username,
      email: email,
      firstName: firstName,
      lastName: lastName,
    };

    const saveChanges = async () => {
      enableEditMode.value = false;
      await UserService.editUser(updatedUser);
    };

    const formatDate = (stringDate) => {
      const date = new Date(stringDate);
      return moment(date).format('YYYY/MM/DD');
    };

    const audienceNodes = computed({
      get: () => store.state.advancedSearch.audience,
    });

    //This is just hidden for now, don't remove it:
    /*
    const industriesNodes = computed({
      get: () => store.state.advancedSearch.industries,
    });
    */

    const locationsNodes = computed({
      get: () => store.state.advancedSearch.locations,
    });

    const purposesNodes = computed({
      get: () => store.state.advancedSearch.purposes,
    });

    const locationsOptions = computed({
      get: () => store.state.advancedSearch.locationsOptions,
    });

    const filterFavoriteLocationsTags = ref(locationsOptions.value);

    const selectedFavoriteLocations = computed({
      get: () => store.state.user.selectedFavoriteLocations,
      set: (value) => {
        store.commit('user/updateSelectedFavoriteLocations', value);
        UserService.setFavoriteTags(value, 'Locatie');
      },
    });

    const sendAudienceUpdates = () => {
      UserService.setFavoriteTags(
        audiencePairs.value,
        'Voor wie zoekt u subsidies?'
      );
    };

    const sendPurposesUpdates = () => {
      UserService.setFavoriteTags(purposesPairs.value, 'Onderwerp');
    };

    //This is just hidden for now, don't remove it:
    /*
    const sendIndustriesUpdates = () => {
      UserService.setFavoriteTags(
        industriesPairs.value,
        'Industrieën'
      );
    };
    */

    const showConfirmation = computed({
      get: () => store.state.user.showConfirmation,
    });

    const disableConfirmation = () => {
      store.commit('user/disableConfirmation');
    };

    const showAdminPanel = computed({
      get: () => store.state.auth.authUser.showAdminPanel,
    });

    const goToTab = (tabName) => {
      tab.value = tabName;
    };

    const isVind = computed({
      get: () => store.state.auth.env === 0 || store.state.auth.env === 40
    });
    return {
      isVind,
      goToTab,
      frequencyNL,
      subTab,
      tab,
      tagsTab,
      splitterModel: ref(20),
      user,
      enableEditMode,
      saveChanges,
      updatedUser,
      username,
      email,
      firstName,
      lastName,
      formatDate,
      audienceNodes,
      purposesNodes,
      locationsNodes,
      //This is just hidden for now, don't remove it:
      //industriesNodes,
      filterFavoriteLocationsTags,
      selectedFavoriteLocations,
      filterAudience,
      //This is just hidden for now, don't remove it:
      //filterIndustries,
      filterPurposes,
      tickedAudience,
      selectedAudience,
      expandedAudience,
      //This is just hidden for now, don't remove it:
      // tickedIndustries,
      // selectedIndustries,
      // expandedIndustries,
      tickedPurposes,
      expandedPurposes,
      selectedPurposes,
      sendAudienceUpdates,
      sendPurposesUpdates,
      //This is just hidden for now, don't remove it:
      //sendIndustriesUpdates,
      audiencePairs,
      purposesPairs,
      //This is just hidden for now, don't remove it:
      //industriesPairs,
      updateAudiencePairs,
      updatePurposesPairs,
      //This is just hidden for now, don't remove it:
      //updateIndustriesPairs,
      audienceTree,
      purposesTree,
      //This is just hidden for now, don't remove it:
      //industriesTree,
      // updateSelected,
      favoriteAudience,
      favoritePurposes,
      //This is just hidden for now, don't remove it:
      //favoriteIndustries,
      customer,
      frequency,
      route,
      showConfirmation,
      disableConfirmation,
      schemeChangesInNewsletter,
      openDetailsInNewTab,
      showAdminPanel,
      myFilterMethod(node, filter) {
        const filt = filter.toLowerCase();
        return node.label && node.label.toLowerCase().indexOf(filt) > -1;
      },
      filterLocationsFn(val, update, abort) {
        if (val.length < 1) {
          abort();
          return;
        }
        update(() => {
          if (val === '') {
            filterFavoriteLocationsTags.value = locationsOptions.value;
          } else {
            const needle = val.toLowerCase();

            filterFavoriteLocationsTags.value = locationsOptions.value.filter(
              (v) =>
                v.label
                  .split(/,(.+)/)[0]
                  .toLowerCase()
                  .indexOf(needle) > -1
            );
          }
        });
      },
      barStyle: {
        right: '2px',
        borderRadius: '9px',
        backgroundColor: '#f0f2f5',
        width: '8px',
        opacity: 0.2,
      },
      thumbStyle: {
        right: '4px',
        borderRadius: '7px',
        backgroundColor: '#0a108f',
        width: '4px',
        opacity: 0.75,
      },
    };
  },
};
</script>
